import { render, staticRenderFns } from "./gds-list-grid-3.vue?vue&type=template&id=ff0a9138&scoped=true&"
import script from "./gds-list-grid-3.vue?vue&type=script&lang=js&"
export * from "./gds-list-grid-3.vue?vue&type=script&lang=js&"
import style0 from "./gds-list-grid-3.vue?vue&type=style&index=0&id=ff0a9138&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0a9138",
  null
  
)

export default component.exports